<ion-header>&nbsp;</ion-header>
<ion-content class="ion-padding">
  <form [formGroup]="form" (ngSubmit)="confirm()" class="ask-host-form">
    <label>
      What would you like to ask the host?
      <br />
      <textarea autofocus formControlName="message"></textarea>
    </label>
    <div class="button-wrapper" style="display: flex">
      <button type="submit" class="cnt-button" style="margin-right: 20px">
        <div class="cnt-button-mock">Send</div>
      </button>
      <button type="button" class="cnt-button" (click)="decline()">
        <div class="cnt-button-mock">Cancel</div>
      </button>
    </div>
  </form>
</ion-content>
